import { render, staticRenderFns } from "./QuestionFeedback.vue?vue&type=template&id=745a8d55&scoped=true&"
import script from "./QuestionFeedback.vue?vue&type=script&lang=js&"
export * from "./QuestionFeedback.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFeedback.vue?vue&type=style&index=0&id=745a8d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a8d55",
  null
  
)

export default component.exports